<template>
  <div no-body class="mb-1 p-1 bg-white">
    <div header-tag="header" class="p-1" role="tab">
      <b-button
        v-b-toggle="PHSReportType"
        block
        class="d-flex collapseHeadStyle"
        @click="isVisibleVI = !isVisibleVI"
      >
        <p class="mb-0 text-dark font-weight-bold">Property History Search </p>
        <strong class="ml-auto"
          ><i
            :class="`fa fa-angle-${isVisibleVI ? 'up' : 'down'} text-dark`"
          ></i
        ></strong>
      </b-button>
    </div>
    <b-collapse :id="PHSReportType" visible>
      <div v-if="PHS_ERROR === null">
      <b-row v-if="propertyInformation.length > 0">
        <b-col
          v-for="(data, index) in propertyInformation"
          :key="index"
          cols="12"
          class="mt-1 baseContentFont"
        >
          <div class="px-3 border m-1">
            <b-row class="my-2">
              <b-col md="9"
                ><div
                  ><b>{{
                    formatData(data.propertyReportResponse[0].address)
                  }}</b></div
                ><div
                  ><b>{{
                    formatData(data.propertyReportResponse[0].address1)
                  }}</b></div
                ></b-col
              >
              <b-col
                ><div
                  ><b>County: </b
                  >{{ formatData(data.propertyReportResponse[0].county) }}</div
                ><div
                  ><b>APN: </b
                  >{{ formatData(data.propertyReportResponse[0].apn) }}</div
                ></b-col
              >
            </b-row>
            <div>
              <b-row
                ><b-col
                  ><b>Legal Description: </b
                  >{{
                    formatData(data.propertyReportResponse[0].legalDescription)
                  }}</b-col
                ></b-row
              >
            </div>
            <div class="mt-1">
              <BaseELabel label="Transaction History" class="mb-2" new-style/>
              <b-table
                :items="data.transModel"
                :fields="propertyFields"
                hover
                striped
                bordered
                responsive
                class="mb-0 fraudReportHeaderTable"
                :class="$style.transModelTable"
              >
                <template v-slot:thead-top="">
                  <b-tr>
                    <b-th>Recording Date</b-th>
                    <b-th> Buyer/Borrower</b-th>
                    <b-th>Sale Price</b-th>
                    <b-th>Deed Type</b-th>
                    <b-th>Loan Type</b-th>
                    <b-th rowspan="2" style="vertical-align: middle;"
                      >Document Type</b-th
                    >
                  </b-tr>
                </template>

                <template v-slot:cell(buyer)="rowitem">
                  <span v-for="(x, i) in rowitem.item.buyer" :key="i"
                    >{{ x.trim()
                    }}<span v-if="i < rowitem.item.buyer.length - 1"
                      >,
                    </span></span
                  >
                  <span>/</span>
                  <span v-for="(x, i) in rowitem.item.borrower" :key="i"
                    >{{ x.trim()
                    }}<span v-if="i < rowitem.item.borrower.length - 1"
                      >,
                    </span></span
                  >
                </template>
                <template v-slot:cell(contractDate)="rowitem"
                  ><div class="border-bottom">{{
                    rowitem.item.recordDate || ' '
                  }}</div>
                  <div>{{ rowitem.item.contractDate }}</div>
                </template>
                <template v-slot:cell(seller)="rowitem"
                  ><div class="border-bottom">
                    <span v-if="rowitem.item.buyer.length > 0"> {{ rowitem.item.buyer.toString() }} </span>

                    <span v-if="rowitem.item.borrower.length > 0"> {{ rowitem.item.borrower.toString() }}</span>
                  </div>
                  <div>{{ rowitem.item.seller }}</div>
                </template>
                <template v-slot:cell(loanAmout)="rowitem"
                  ><div class="border-bottom">{{
                    rowitem.item.salePrice || ' '
                  }}</div>
                  <div>{{ rowitem.item.loanAmout }}</div>
                </template>
                <template v-slot:cell(propertyUse)="rowitem"
                  ><div class="border-bottom">{{
                    rowitem.item.deedType || ' '
                  }}</div>
                  <div>{{ rowitem.item.propertyUse }}</div>
                </template>
                <template v-slot:cell(lender)="rowitem"
                  ><div class="border-bottom">{{
                    rowitem.item.loanType || ' '
                  }}</div>
                  <div>{{ rowitem.item.lender }}</div>
                </template>

                <template v-slot:cell(documentType)="rowitem">
                  {{ rowitem.item.documentType }}
                </template>
              </b-table>
              <NoRecordFound v-if="!data.transModel.length"></NoRecordFound>
            </div>

            <div class="mt-2">
              <BaseELabel label="Assessor Record" class="mb-2" new-style />
              <div
                v-if="data.taxModel
                  ? Object.values(data.taxModel).some(
                    (x) => x !== null && x !== '' && x.length !== 0
                  )
                  : null
                  "
                class="border px-3 py-1 mb-3"
              >
                <b-row>
                  <b-col
                    ><b>Sub Division: </b
                    >{{ formatData(data.taxModel.subDivisionNameTax) }}</b-col
                  >
                  <b-col
                    ><b>Tax Amount: </b
                    >{{ formatData(data.taxModel.taxAmount) }}</b-col
                  >
                  <b-col
                    ><b>Owner Address: </b
                    ><span v-for="(x, i) in data.taxModel.ownerAddress" :key="i"
                      >{{ formatData(x)
                      }}<span v-if="i < data.taxModel.ownerAddress.length - 1"
                        >,
                      </span></span
                    ></b-col
                  >
                </b-row>
                <b-row>
                  <b-col cols="4"
                    ><b>Tax Year: </b
                    >{{ formatData(data.taxModel.taxYear) }}</b-col
                  >
                  <b-col cols="4"
                    ><b>Owner Name: </b
                    ><span v-for="(x, i) in data.taxModel.owners" :key="i"
                      >{{ formatData(x)
                      }}<span v-if="i < data.taxModel.owners.length - 1"
                        >,
                      </span></span
                    ></b-col
                  >
                </b-row>
              </div>
              <NoRecordFound v-else class="mb-2" />
            </div>
          </div>
        </b-col>
      </b-row>
      <NoRecordFound v-else class="mx-1"></NoRecordFound>
    </div>
      <CustomMessage v-else :custom-msg="PHS_ERROR"/>
    </b-collapse>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
import CustomMessage from '@/src/components/_custom-message.vue'


export default {
  components: { NoRecordFound,CustomMessage },
  props: {
    propertyHistory: {
      type: Object,
      default: () => {},
    },
    reportType: {
      type: String,
      default: '',
    },
    phsMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisibleVI: false,
      propertyFields: [
        {
          key: 'contractDate',
          label: 'Contract Date',
          tdClass: 'textpadding',
        },
        {
          key: 'seller',
          label: 'Seller',
          class: 'text-left ',
          tdClass: 'textpadding',
        },
        {
          key: 'loanAmout',
          label: 'Loan Amount',
          class: 'text-left ',
          tdClass: 'textpadding',
        },
        {
          key: 'propertyUse',
          label: 'Property Use',

          tdClass: 'textpadding',
        },
        {
          key: 'lender',
          label: 'Lender',
          class: 'text-left ',
          tdClass: 'textpadding',
        },
        {
          key: 'documentType',
          label: 'Document Type',
          class: 'text-left ',
          tdClass: 'textpadding',
          thClass: 'd-none',
        },
      ],
    }
  },
  computed: {
    propertyInformation() {
      return this.propertyHistory ? this.propertyHistory.phsData : [] || []
    },
    PHSReportType() {
      return this.reportType
    },
    PHS_ERROR() {
      return this.phsMessage
    },
  },
  methods: {
    formatData(value) {
      return value || null
    },
    getPropertyList(propertyData) {
      let resList = propertyData || []
      if (resList.length === 1) {
        resList.map((x, i) => {
          if (
            i === 0 &&
            (x.deedType === '' || x.deedType === null) &&
            (x.documentType === '' || x.documentType === null) &&
            (x.lenderType === '' || x.lenderType === null) &&
            (x.loanType === '' || x.loanType === null) &&
            (x.propertyUse === '' || x.propertyUse === null) &&
            (x.subDivisionName === '' || x.subDivisionName === null) &&
            (x.financingDesc === '' || x.financingDesc === null) &&
            (x.vestingDesc === '' || x.vestingDesc === null)
          ) {
            resList = []
          }
        })
      }
      return resList
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
.collapseHeadStyle {
  background-color: $color-raisin-40 !important;
  border: none;
}

.textpadding {
  vertical-align: middle;

  div {
    padding: 5px;
  }
}
</style>

<style lang="scss" module>
@import '@design';

.transModelTable tr td {
  vertical-align: middle;
}
</style>
